import { gql } from '@apollo/client'

export default gql`
  query {
    ownedGroups {
      id
      name
      color
      archived
      owner {
        id
        lastName
      }
      sections {
        id
        code
        name
        archived
        students {
          id
          name
        }
      }
    }
    otherGroups {
      id
      name
      color
      archived
      owner {
        id
        lastName
        role
      }
      sections {
        id
        code
        name
        archived
        students {
          id
          name
        }
      }
    }
  }
`
